import React, { useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Tooltip } from 'devextreme-react/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setCambiarContrasena } from '../utils/api';
import { Hypnosis } from "react-cssfx-loading";
import { notificacionSuccess, notificacionError } from '../utils/alerts';

export default function Cambio_Contraseña_Pases_Pendientes(props) {
    let inputPSW1 = useRef(null);
    let inputPSW2 = useRef(null);
    const [show, setShow] = useState(false);
    const [form, setForm] = useState({ usuario: "", contraseña: "", nueva_contraseña: "" });
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipOpenClose, setTooltipOpenClose] = useState(false);
    const [usuario, setUsuario] = useState(null);
    const [error, setError] = useState(true);
    const [loading, setLoading] = useState(false);
    const [isPassword, setIsPassword] = useState(true);

    useEffect(() => {
        setShow(props.abrirModal);
        setUsuario(sessionStorage.getItem("user"));
        return () => {
            setShow(false);
        }
    })

    const toolTip = () => setTooltipOpen(!tooltipOpen);
    const toolTipClose = () => setTooltipOpenClose(!tooltipOpenClose);

    const formChange = (campo, e) => {
        setForm({ ...form, [campo]: e.value });
        setError(true);
    }

    const cerrarModal = () => {
        setShow(false);
        props.cerrarModal(false);
        setForm({ usuario: "", contraseña: "", nueva_contraseña: "" });
    }

    const esPassword = (t) => {
        console.log(t);
        setIsPassword(t);
    };

    const onEnterKey = (event) => {
        if (event.key === 'Enter') {
            guardarNuevaContraseña();
        }
    }

    //METODO PARA CAMBIAR LA CONTRASEÑA
    const guardarNuevaContraseña = () => {
        setLoading(true);
        if (form.nueva_contraseña !== "") {
            setCambiarContrasena(usuario, form.contraseña, form.nueva_contraseña)
                .then(resp => {
                    if (resp.status === 200) {
                        if (resp.data) {
                            notificacionSuccess("Contraseña Modificada");
                            cerrarModal();
                        } else {
                            notificacionError("Intente nuevamente");
                            setError(false);
                        }
                    } else {
                        throw new Error(resp.statusText);
                    }
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    console.log(err);
                    notificacionError("Intentelo nuevamente, si el error persite favor de comunicarse con el administrador del sistema");
                });
        } else {
            setLoading(false);
            notificacionError("Favor de escribir una nueva contraseña");
        }
    }

    const handleEnter = (event) => {
        if (event.key === 'Enter') {
            // inputPSW2.current.instance.focus();
            console.log(inputPSW2.current.focus());
        }
    }

    return (
        <div>
            <Modal isOpen={show} toggle={cerrarModal} backdrop="static">
                <ModalHeader>Modificar Contraseña de Inventarios</ModalHeader>
                {loading ?
                    <Hypnosis width="100px" height="100px" style={{ margin: "0 auto", marginBottom: "1rem" }} />
                    :
                    <>
                        <ModalBody>
                            <Row>
                                <Col>
                                    <Card>
                                        <CardHeader>
                                            <div className="text-center">
                                                <h4>Inventarios</h4>
                                            </div>
                                        </CardHeader>
                                        <CardBody>
                                            <form>
                                                <Row>
                                                    <Col sm={{ size: 12 }}>
                                                        <label className="col-form-label fs-6 fw-bold">Contraseña Actual</label>
                                                        {/* <TextBox
                                                        mode="tel"
                                                        showClearButton={true}
                                                        placeholder="Contraseña Actual"
                                                        valueChangeEvent="keyup"
                                                        onValueChanged={(e) => formChange("contraseña", e)}
                                                        value={form.contraseña} /> */}
                                                        <input
                                                            ref={inputPSW1}
                                                            name='contraseña'
                                                            style={{ WebkitTextSecurity: 'disc' }}
                                                            type="tel"
                                                            inputMode='tel'
                                                            className="form-control"
                                                            placeholder='Contraseña Actual'
                                                            onKeyDown={handleEnter}
                                                            onChange={(e) => formChange("contraseña", e.target)}
                                                            value={form.contraseña} />
                                                        <label className="col-form-label fs-6 fw-bold text-danger" hidden={error}>Contraseña Incorrecta</label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm={{ size: 12 }}>
                                                        <label className="col-form-label fs-6 fw-bold">Nueva Contraseña</label>
                                                        {/* <TextBox
                                                        mode="password"
                                                        showClearButton={true}
                                                        placeholder="Nueva Contraseña"
                                                        valueChangeEvent="keyup"
                                                        onValueChanged={(e) => formChange("nueva_contraseña", e)}
                                                        value={form.nueva_contraseña} >
                                                        <Validator>
                                                            <RequiredRule message="Contraseña Requerida" />
                                                        </Validator>
                                                    </TextBox> */}
                                                        <input
                                                            ref={inputPSW2}
                                                            name='password'
                                                            style={{ WebkitTextSecurity: 'disc' }}
                                                            type="tel"
                                                            inputMode='tel'
                                                            className="form-control"
                                                            placeholder='Nueva Contraseña'
                                                            onChange={(e) => formChange("nueva_contraseña", e.target)}
                                                            onKeyUp={onEnterKey}
                                                            value={form.nueva_contraseña} >
                                                            {/* <Validator>
                                                            <RequiredRule message="Contraseña Requerida" />
                                                        </Validator> */}
                                                        </input>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <button id="btnGuardar"
                                className="btn btn-outline-success"
                                onClick={guardarNuevaContraseña}
                                onMouseEnter={toolTip}
                                onMouseLeave={toolTip}>
                                <FontAwesomeIcon icon="check" size="2x" />
                            </button>
                            <Tooltip
                                target="#btnGuardar"
                                position="top"
                                visible={tooltipOpen}
                                closeOnOutsideClick={false}
                            >
                                <div>Aceptar</div>
                            </Tooltip>
                            <button id="btnCancelarModificacion"
                                className="btn btn-outline-danger"
                                onClick={cerrarModal}
                                onMouseEnter={toolTipClose}
                                onMouseLeave={toolTipClose}>
                                <FontAwesomeIcon icon="times" size="2x" />
                            </button>
                            <Tooltip
                                target="#btnCancelarModificacion"
                                position="top"
                                visible={tooltipOpenClose}
                                closeOnOutsideClick={false}
                            >
                                <div>Cancelar</div>
                            </Tooltip>
                        </ModalFooter>
                    </>
                }
            </Modal>
        </div>
    )
}
